
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import ProgressCircle from "./ProgressCircle";

const StatBox = ({ title, subtitle, icon, progress, increase ,image,total}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const percentage = total ? `${Math.round((title.split('/')[0] / total) * 100)}%` : null;

  return (
    <Box
      width="100%"
      m="0 15px"
      p="10px"
      borderRadius="6px"
      
      sx={{
        backgroundColor: colors.primary[400],
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        transition: "transform 0.3s ease, box-shadow 0.3s ease",
        "&:hover": {
          transform: "translateY(-5px)",
          boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" >
        <Box>
         {icon}
        <img
            src={image}
            alt="Stat Icon"
            style={{ width: "30px", height: "30px", marginBottom: "8px" }} // Adjust size as needed
          />
          <Typography
            variant="h4"
            fontWeight="bold"
            sx={{ color: colors.grey[100], mt: 1, }}
          >
            {title}
            {percentage && (
                <Typography 
                  component="span" 
                  variant="h4"
                  sx={{ 
                    
                    color: colors.greenAccent[500],
                    ml: 1,
                    paddingLeft:'2rem',
                    fontWeight: 'bold'
                  }}
                >
                  {percentage}
                </Typography>
              )}
          </Typography>
        </Box>
        {/* Uncomment if you want to include the progress circle */}
        {/* <Box>
          <ProgressCircle progress={progress} />
        </Box> */}
      </Box>
      <Box display="flex" justifyContent="space-between" mt="10px">
        <Typography variant="h3" sx={{ color: colors.primary }}>
          {subtitle}
        </Typography>
        {/* Uncomment if you want to include the increase text */}
        {/* <Typography
          variant="h6"
          fontStyle="italic"
          sx={{ color: colors.greenAccent[600] }}
        >
          {increase}
        </Typography> */}
      </Box>
    </Box>
  );
};

export default StatBox;


// import { Box, Typography, useTheme } from "@mui/material";
// import { tokens } from "../theme";
// import ProgressCircle from "./ProgressCircle";

// const StatBox = ({ title, subtitle, progress, image, total }) => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);

//   // Calculate percentage if total is provided
//   const percentage = total ? `${Math.round((title.split('/')[0] / total) * 100)}%` : null;

//   return (
//     <Box
//       width="100%"
//       m="0 20px"
//       p="20px"
//       borderRadius="8px"
//       sx={{
//         backgroundColor: colors.primary[400],
//         boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
//         transition: "transform 0.2s ease, box-shadow 0.2s ease",
//         "&:hover": {
//           transform: "translateY(-3px)",
//           boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
//         },
//       }}
//     >
//       <Box display="flex" justifyContent="space-between" alignItems="center">
//         <Box display="flex" alignItems="center" gap={2}>
//           <img
//             src={image}
//             alt="Stat Icon"
//             style={{ width: "24px", height: "24px" }}
//           />
//           <Box>
//             <Typography
//               variant="h5"
//               fontWeight="bold"
//               sx={{ color: colors.grey[100], lineHeight: 1.2 }}
//             >
//               {title}
//               {percentage && (
//                 <Typography 
//                   component="span" 
//                   variant="body2"
//                   sx={{ 
//                     color: colors.greenAccent[500],
//                     ml: 1,
//                     fontWeight: 'bold'
//                   }}
//                 >
//                   {percentage}
//                 </Typography>
//               )}
//             </Typography>
//             <Typography 
//               variant="h4" 
//               sx={{ 
//                 color: colors.grey[300],
//                 fontSize: '1.2rem',
//                 mt: 0.5
//               }}
//             >
//               {subtitle}
//             </Typography>
//           </Box>
//         </Box>
//         {progress && (
//           <Box width="50px" height="50px">
//             {/* <ProgressCircle progress={progress} size={50} /> */}
//           </Box>
//         )}
//       </Box>
//     </Box>
//   );
// };

// export default StatBox;